import * as React from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

// shadcn/ui Toaster — wraps `sonner` with project defaults (dark theme, position).
// Use `import { toast } from 'sonner'` to fire toasts from anywhere; mount
// `<Toaster />` once near the app root.
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-zinc-900 group-[.toaster]:text-zinc-100 group-[.toaster]:border-zinc-800 group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-zinc-400',
          actionButton: 'group-[.toast]:bg-sky-500 group-[.toast]:text-zinc-950',
          cancelButton: 'group-[.toast]:bg-zinc-800 group-[.toast]:text-zinc-300',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
